export const CAN_REPLY_REVIEW = 'Responder avaliações'
export const CAN_APPROVE_REVIEW = 'Aprovar avaliações'
export const CAN_GENERATE_REPORT = 'Gerar relatório'
export const CAN_MANAGE_LOCATIONS = 'Gerenciar locais'
export const CAN_MANAGE_LOCAL_POSTS = 'Gerenciar posts'
export const CAN_STORE_TAGS = 'Adicionar tags'
export const CAN_VIEW_TAGS = 'Visualizar tags'
export const CAN_UPDATE_TAGS = 'Atualizar tags'
export const CAN_GROUP_TAGS = 'Agrupar tags'
export const CAN_DELETE_TAGS = 'Excluir tags'
export const CAN_STORE_AUTOMATIC_RESPONSE = 'Adicionar respostas automáticas'
export const CAN_VIEW_AUTOMATIC_RESPONSE = 'Visualizar respostas automáticas'
export const CAN_UPDATE_AUTOMATIC_RESPONSE = 'Atualizar respostas automáticas'
export const CAN_DELETE_AUTOMATIC_RESPONSE = 'Excluir respostas automáticas'
export const CAN_MANAGE_TASKS = 'Gerenciar tarefas'